import React from "react";
import { Link } from "react-router-dom";
import { AppHeader } from "@/components/AppHeader";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] grain">
      <AppHeader />
      <main className="max-w-xl mx-auto px-6 py-20 text-center space-y-4" data-testid="payment-cancelled">
        <h1 className="font-serif-display text-4xl text-[#1C221D]">No worries, baby.</h1>
        <p className="text-[#5C6A61]">Checkout was cancelled and you haven't been charged. The Reset will be here when you're ready.</p>
        <div className="flex justify-center gap-4 pt-2">
          <Link to="/program" className="px-6 py-3 rounded-full bg-[#2A3B32] text-[#FDFBF7]" data-testid="cancel-view-program">View the program</Link>
          <Link to="/dashboard" className="px-6 py-3 rounded-full border border-[#2A3B32]/15 text-[#1C221D]">Dashboard</Link>
        </div>
      </main>
    </div>
  );
}
